import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { getConfig, getCriancaAtiva, salvarConfig } from "../../db/queries";
import { idade } from "../../lib/format";

/**
 * Configurações do Gingado. Paciente/responsável e backup são compartilhados entre
 * os módulos do Degrau; aqui só os ajustes do módulo de psicomotricidade.
 */
export function ConfigCorpo() {
  const nav = useNavigate();
  const cfg = useLiveQuery(getConfig);
  const crianca = useLiveQuery(getCriancaAtiva);
  const anos = idade(crianca?.data_nascimento ?? null);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <h1 className="tela-titulo">configurações · Gingado</h1>

      <section className="secao">
        <h2 className="secao-titulo">paciente</h2>
        <button
          className="card linha-alimento"
          onClick={() => nav("/paciente")}
          style={{ width: "100%" }}
        >
          <div className="foto" aria-hidden>
            👤
          </div>
          <div className="crescer">
            {crianca ? (
              <>
                <div className="nome">
                  {crianca.nome_completo || crianca.apelido}
                  {anos !== null && (
                    <span className="meta"> · {anos} {anos === 1 ? "ano" : "anos"}</span>
                  )}
                </div>
                <div className="meta">o cadastro é compartilhado entre os módulos</div>
              </>
            ) : (
              <>
                <div className="nome">completar cadastro</div>
                <div className="meta">paciente e responsável</div>
              </>
            )}
          </div>
          <span aria-hidden>→</span>
        </button>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">lembrete de rotina</h2>
        <div className="card">
          <div className="campo" style={{ margin: 0 }}>
            <label>retomar uma atividade em exploração a cada (dias)</label>
            <input
              type="number"
              min={1}
              max={30}
              value={cfg?.gingado_rotina_dias ?? 5}
              onChange={(e) => salvarConfig({ gingado_rotina_dias: Number(e.target.value) })}
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">modo escolha da criança</h2>
        <div className="card">
          <div className="campo" style={{ margin: 0 }}>
            <label>quantas opções aparecem (2 ou 3)</label>
            <input
              type="number"
              min={2}
              max={3}
              value={cfg?.gingado_escolha_qtd ?? 2}
              onChange={(e) =>
                salvarConfig({
                  gingado_escolha_qtd: Math.max(2, Math.min(3, Number(e.target.value))),
                })
              }
            />
          </div>
        </div>
      </section>

      <section className="secao">
        <h2 className="secao-titulo">segurança & privacidade</h2>
        <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>
          movimento tem risco real (queda, sobrecarga vestibular): o cuidado de segurança
          aparece antes da atividade e o app nunca empurra intensidade. tudo fica neste
          aparelho, sem conta. fotos e clipes de vídeo do corpo da criança só saem quando
          você exporta.
        </p>
      </section>
    </main>
  );
}
